import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

export type RegistroInformativoDialogType = 'info' | 'warning' | 'error' | 'success';

export interface RegistroInformativoDialogData {
  title: string;
  message?: string;
  messages?: string[];
  imageSrc?: string;
  imageAlt?: string;
  icon?: string;
  type?: RegistroInformativoDialogType;
  actionText?: string;

  showCancelButton?: boolean;
  confirmText?: string;
  cancelText?: string;
}

@Component({
    selector: 'app-registro-informativo-dialog',
    templateUrl: './registro-informativo-dialog.component.html',
    styleUrls: ['./registro-informativo-dialog.component.scss'],
    imports: [NgClass, MatIcon]
})
export class RegistroInformativoDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<RegistroInformativoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: RegistroInformativoDialogData
  ) {}

  get dialogType(): RegistroInformativoDialogType {
    return this.data.type || 'info';
  }

  get icon(): string {
    if (this.data.icon) {
      return this.data.icon;
    }

    switch (this.dialogType) {
      case 'warning':
        return 'error_outline';
      case 'error':
        return 'highlight_off';
      case 'success':
        return 'check_circle';
      default:
        return 'info';
    }
  }

  confirmar(): void {
    this.dialogRef.close(true);
  }

  cancelar(): void {
    this.dialogRef.close(false);
  }

  cerrar(): void {
    this.dialogRef.close(false);
  }
}